<template>

    <div id="gheom_view">

        <div id="gheom-yield">

            <slot></slot>

        </div>

    </div>

</template>

<style lang="scss" scoped >

</style>


<script>

    export default {

        props: {
            mainpage: {},
            user: {},
            options: {},
        },


        data: function(){

            return {

                url: '/profile.pic',
            };

        },

        methods: {

        }
    }
</script>
